/*
 * Post-login.ts
 * Description: Includes function for sending a request
  * to get a JWT, hence, to log in the user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL, TooManyAttempts, WrongCredentials} from '@/ts/variables';
// Importing interface
import {User} from '@/ts/auth/validate-login';

/**
 * Logging in users
 *
 * @param errors - list of errors
 * @param data - user data
 * @return {Object} Promise - whether logging in has been successful
 */
export function postLogin(errors: string[], data: User) {
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'auth/login',
            method: 'post',
            data,
        }).then((response) => {
            const authData = response.data.data;
            // Construct an expiration date
            const date = new Date(new Date().getTime() + (1000 * authData.expires_in));
            // Construct local storage items
            localStorage.setItem('user', authData.user.first_name + ' ' + authData.user.last_name);
            localStorage.setItem('id', authData.user.id);
            localStorage.setItem('jwt', authData.access_token);
            localStorage.setItem('expireDate', String(date));
            resolve();
        }).catch((error) => {
            const err = error.response.data;
            // Checking if the field errors exists in data, to prevent errors
            if (Array.isArray(err.errors)) {
                const message = err.errors[0].message;
                if (message === 'Wrong credentials.') {
                    errors.push(WrongCredentials);
                } else if (message.includes('Too many login attempts.')) {
                    errors.push(TooManyAttempts);
                } else {
                    errors.push(message);
                }
            }
            reject();
        });
    });
}
